import { useEffect, useState } from "react";
import getBaseUrl from "../../lib/utils/getBaseUrl";
import Fundamentei from "../branding/Fundamentei";

export default function WholePageLoadingBlankslate() {
  const [tryToRefreshManually, setShowTryToRefreshManually] = useState(false);

  useEffect(() => {
    const tryToRefreshManuallyTimeout = setTimeout(() => setShowTryToRefreshManually(true), 6000);
    return () => clearTimeout(tryToRefreshManuallyTimeout);
  }, []);

  return (
    <>
      <style jsx={true} global={true}>
        {`
          html,
          body {
            height: 100%;
          }
        `}
      </style>

      <div className="flex h-full w-full items-center justify-center bg-indigo-50">
        <div className="grid gap-y-5 text-center">
          <div>
            <Fundamentei width={106} height={101} />
          </div>

          <h1 className="m-0 font-bold text-blue-600">{tryToRefreshManually ? "Aguarde :(" : "Aguarde..."}</h1>

          {tryToRefreshManually && (
            <p className="m-0 text-base font-medium tracking-wider text-slate-600 dark:text-slate-400">
              {"Investidor—caso essa página permaneça por muito tempo, "}
              <a
                title="Atualizar página"
                href={getBaseUrl()}
                className="text-blue-600 underline hover:text-blue-700 dark:text-blue-400"
              >
                tente atualizar manualmente.
              </a>
            </p>
          )}
        </div>
      </div>
    </>
  );
}
